import React, { useState } from 'react';
import { CardHeader, Chip } from '@material-ui/core';
import { List, Datagrid, TextField, ReferenceField, FunctionField, NumberField, useRecordContext } from 'react-admin';
import { green, grey } from "@material-ui/core/colors";
import EmpActionMenu from './EmpActionMenu';
import SearchInput from '../SearchInput';
import BulkDeleteButton from '../BulkDeleteButton';
const StatusChip = () => {
    const record = useRecordContext();

    if(!record || typeof record.isActive === "undefined") return null;

    const isActive = record.isActive;
    const text = isActive ? "active" : "inactive";
    const color = isActive ? green[500] : grey[600];
    
    return (
        <Chip
            label={text.toUpperCase()}
            style={{
                backgroundColor: color,
                color: "#fff",
                borderRadius: "4px",
                fontWeight: "bold",
            }}
        />
    )
}

const EmployeeList = ({ empList, actions, resource="employees", clientId, isAdmin, ...props }) => {
    const [filteredData, setFilteredData] = useState(empList || []);

    const hanldeFilteredData = (filteredData) => {
        setFilteredData(filteredData)
    };

    const searchFilters = (
        <SearchInput 
            searchKeys={["fullName", "employeeNumber", "cardNumber"]} 
        />
    );

    let filter = { isActive: true };
    if(clientId) {
        filter = {
            "client": clientId
        }
    }

    return (
        <>
            <div style={{ width: '90%' }}>
                <CardHeader title="Employee List" />
                {empList && (
                    <>
                        <div style={{ width: '100%', overflowX: 'auto' }}>
                            <List
                                {...props}
                                resource="employees"
                                actions={actions}
                                filter={filter}
                                filters={searchFilters}
                                perPage={25}
                                empty={false}
                                sort={{ field: 'createdAt', order: 'DESC' }}
                            >
                                <Datagrid 
                                    {...props}
                                    bulkActionButtons={<BulkDeleteButton resource="employees" />}
                                    sx={{ 
                                        minWidth: '1200px',
                                        tableLayout: 'fixed',
                                        '& .RaDatagrid-headerCell': { fontWeight: 'bold' },
                                        '& .RaDatagrid-headerCell:nth-of-type(1), & .RaDatagrid-rowCell:nth-of-type(1)': {
                                            width: '20px',
                                        },
                                        '& .RaDatagrid-headerCell:nth-of-type(2), & .RaDatagrid-rowCell:nth-of-type(2)': {
                                            width: '250px',
                                        },
                                        '& .RaDatagrid-headerCell:nth-of-type(3), & .RaDatagrid-rowCell:nth-of-type(3)': {
                                            width: '150px',
                                        },
                                        '& .RaDatagrid-headerCell:nth-of-type(4), & .RaDatagrid-rowCell:nth-of-type(4)': {
                                            width: '150px',
                                        },
                                        '& .RaDatagrid-headerCell:nth-of-type(5), & .RaDatagrid-rowCell:nth-of-type(5)': {
                                            width: '120px',
                                        },
                                        '& .RaDatagrid-headerCell:nth-of-type(6), & .RaDatagrid-rowCell:nth-of-type(6)': {
                                            width: '150px',
                                        },
                                        '& .RaDatagrid-headerCell:nth-of-type(7), & .RaDatagrid-rowCell:nth-of-type(7)': {
                                            width: '130px',
                                        },
                                        '& .RaDatagrid-headerCell:nth-of-type(8), & .RaDatagrid-rowCell:nth-of-type(8)': {
                                            width: '130px',
                                        },
                                        '& .RaDatagrid-headerCell:nth-of-type(9), & .RaDatagrid-rowCell:nth-of-type(9)': {
                                            width: '100px',
                                        },
                                        '& .RaDatagrid-headerCell:nth-of-type(10), & .RaDatagrid-rowCell:nth-of-type(10)': {
                                            width: '80px',
                                        },
                                    }}
                                >
                                    <TextField source="fullName" label="Full Name" />
                                    {isAdmin && (
                                        <ReferenceField label="Company" source="client" reference="clients" link={false}>
                                            <TextField source="companyName" />
                                        </ReferenceField>
                                    )}
                                    <TextField source="employeeNumber" label="Employee No." />
                                    <TextField source="cardNumber" label="Card No." />
                                    <TextField source="type.name" label="Type" />
                                    <TextField source="costCenter" label="Cost Center" />
                                    <FunctionField 
                                        label="Current Credit"
                                        render={record => {
                                            if (record && record.credit != null) {
                                            let creditValue = parseFloat(record.credit);
                                            let roundedValue = Math.round(creditValue * 100) / 100;
                                            return roundedValue.toFixed(2);
                                            }
                                            return null;
                                        }}
                                    />
                                    <NumberField source="recurringCredit" label="Recurring Credit" />
                                    <StatusChip label="Status" />
                                    <EmpActionMenu basePath={props.basePath} resource={resource} />
                                </Datagrid>
                            </List>
                        </div>
                    </>
                )}
            </div>
        </>
    )
};

export default EmployeeList;
